import { AppShell, Badge, Button, Icon, Menu, type NavItem, type NavSection, PRESET_LABELS } from '@wl/ui';
import { Outlet, useNavigate } from 'react-router';
import { useAdmin, useAuth } from '../lib/auth';
import { useAdminTheme } from '../lib/theme';
import { PLATFORM_ROLES } from '../components/labels';
import { MODULES, SECTION_TITLES } from './modules';

function navigation(): { sections: NavSection[]; tabs: NavItem[] } {
  const visible = MODULES.filter((m) => m.nav !== false);
  const sections = (['main', 'catalog', 'security'] as const).map((s) => ({
    title: SECTION_TITLES[s],
    items: visible.filter((m) => m.section === s).map((m) => ({ to: m.path, label: m.label, icon: m.icon, end: m.end })),
  }));
  const tabs = visible
    .filter((m) => m.mobileTab !== undefined)
    .sort((a, b) => (a.mobileTab ?? 0) - (b.mobileTab ?? 0))
    .map((m) => ({ to: m.path, label: m.label, icon: m.icon, end: m.end }));
  return { sections, tabs };
}

export function AdminLayout() {
  const { sections, tabs } = navigation();
  return (
    <AppShell brand={{ name: 'Platform Yönetimi' }} nav={sections} mobileTabs={tabs} topBar={<TopBar />}>
      <Outlet />
    </AppShell>
  );
}

function TopBar() {
  const admin = useAdmin();
  const { logout } = useAuth();
  const { preset, setPreset } = useAdminTheme();
  const navigate = useNavigate();
  const order = ['light', 'dark', 'oled'] as const;
  const next = order[(order.indexOf(preset) + 1) % order.length]!;
  return (
    <>
      <Button variant="ghost" size="icon" title={`Tema: ${PRESET_LABELS[preset]}`} aria-label={`${PRESET_LABELS[next]} temaya geç`} onClick={() => setPreset(next)}>
        <Icon name={preset === 'light' ? 'sun' : 'moon'} size={20} />
      </Button>
      <Menu
        trigger={
          <button type="button" className="flex items-center gap-2 rounded-full p-1 hover:bg-surface md:pr-3" aria-label="Hesap menüsü">
            <span className="flex size-8 items-center justify-center rounded-full bg-primary/15 text-xs font-semibold text-primary">
              {admin.fullName.trim().charAt(0).toUpperCase()}
            </span>
            <span className="hidden text-sm md:block">{admin.fullName}</span>
            <Badge tone={admin.role === 'support' ? 'neutral' : 'primary'} className="hidden md:inline-flex">
              {PLATFORM_ROLES[admin.role].label}
            </Badge>
          </button>
        }
        items={[
          {
            label: 'Çıkış yap',
            danger: true,
            onClick: () => void logout().then(() => navigate('/login')),
          },
        ]}
      />
    </>
  );
}
